<template>
    <v-dialog
        v-model="dialog"
        max-width="500"
        @keydown.esc="cancel"
        :persistent="processing"
    >
        <v-card>
            <v-card-title class="headline">
                {{ $t('actions.bill.negotiate.title') }}
                <v-spacer></v-spacer>
                <v-btn icon @click="dialog = false">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-card-title>
            <v-card-text>
                <p>{{ $t('actions.bill.negotiate.text') }}</p>
                <v-text-field
                    v-model="installments"
                    :label="
                        $t('resources.billNegotiation.attributes.installments')
                    "
                    type="number"
                    :error-messages="installmentsErrors"
                    @input="$v.installments.$touch()"
                    @blur="$v.installments.$touch()"
                />
                <v-text-field
                    v-model="installmentValue"
                    :label="
                        $t(
                            'resources.billNegotiation.attributes.installment_value',
                        )
                    "
                    :hint="
                        $t('resources.billNegotiation.hints.installment_value')
                    "
                    readonly
                />
                <v-dialog ref="dialog" v-model="datepicker" width="290px">
                    <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                            v-model="firstOn"
                            :label="
                                $t(
                                    'resources.billNegotiation.attributes.first_on',
                                )
                            "
                            readonly
                            v-bind="attrs"
                            v-on="on"
                            v-on:append="on"
                            clearable
                            append-icon="mdi-calendar"
                            @click:append="datepicker = true"
                            :error-messages="firstOnErrors"
                            @input="$v.firstOn.$touch()"
                            @blur="$v.firstOn.$touch()"
                        />
                    </template>
                    <v-date-picker
                        v-model="firstOn"
                        type="month"
                        @input="datepicker = false"
                        scrollable
                    />
                </v-dialog>
            </v-card-text>
            <v-card-actions>
                <v-btn
                    class="col"
                    color="red darken-1"
                    text
                    @click="close"
                    :disabled="processing"
                >
                    {{ $t('actions.close') }}
                </v-btn>
                <v-divider vertical=""></v-divider>
                <v-btn
                    class="col"
                    color="green darken-1"
                    text
                    @click="perform"
                    :loading="processing"
                >
                    {{ $t('actions.bill.negotiate.perform') }}
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import { required } from 'vuelidate/lib/validators'
import { validationMixin } from 'vuelidate'

export default {
    data() {
        return {
            dialog: false,
            model: undefined,
            processing: false,
            installments: undefined,
            firstOn: undefined,
            datepicker: false,
        }
    },

    mixins: [validationMixin],

    validations: {
        installments: { required },
        firstOn: { required },
    },

    watch: {
        dialog(value) {
            if (value) return
            this.model = undefined
            this.installments = undefined
            this.firstOn = undefined
            this.datepicker = false
        },
    },

    computed: {
        installmentValue() {
            if (!this.installments) return undefined
            return this.$n(
                this.model.totalValue / this.installments,
                'currency',
            )
        },

        installmentsErrors() {
            const errors = []
            if (!this.$v.installments.$dirty) return errors

            !this.$v.installments.required &&
                errors.push(
                    this.$t('forms.errors.required', {
                        label: this.$t(
                            'resources.billNegotiation.attributes.installments',
                        ),
                    }),
                )

            return errors
        },

        firstOnErrors() {
            const errors = []
            if (!this.$v.firstOn.$dirty) return errors

            !this.$v.firstOn.required &&
                errors.push(
                    this.$t('forms.errors.required', {
                        label: this.$t(
                            'resources.billNegotiation.attributes.first_on',
                        ),
                    }),
                )

            return errors
        },
    },

    methods: {
        open(model) {
            this.dialog = true
            this.model = model
        },

        close() {
            this.model = undefined
            this.dialog = false
        },

        async perform() {
            this.processing = true
            let res = await this.model.negotiate(
                this.installments,
                this.firstOn + '-01',
            )
            this.processing = false
            this.dialog = false
            if (!res) return
            this.$emit('modelChanged')
            this.$bus.$emit(
                'notify',
                'success',
                this.$t('actions.bill.negotiate.success'),
            )
        },
    },
}
</script>

<style></style>
